import React from 'react'
import { styled } from '@mui/material'
import {
  BOTTOM_NAVIGATION_HEIGHT,
  DRAWER_DIMENSIONS,
  PAGE_PADDING_SIDE,
  PAGE_PADDING_TOP,
} from './util/consts'
import TestIds from './testIds'

const ResponseivePageBody = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    width: '100%',
    height: 'fit-content',
    minHeight: '100%',
    padding: `calc(${PAGE_PADDING_TOP.lg}px)  ${PAGE_PADDING_SIDE.lg}px`,

    [theme.breakpoints.down('lg')]: {
      padding: `calc(${PAGE_PADDING_TOP.md}px)  ${PAGE_PADDING_SIDE.md}px`,
    },

    [theme.breakpoints.down('md')]: {
      padding: `calc(${PAGE_PADDING_TOP.sm}px)  ${PAGE_PADDING_SIDE.sm}px`,
    },

    [theme.breakpoints.down('sm')]: {
      padding: `calc(${PAGE_PADDING_TOP.xs}px)  ${PAGE_PADDING_SIDE.xs}px`,
    },

    [theme.breakpoints.down('xs')]: {
      paddingBottom: `calc(${BOTTOM_NAVIGATION_HEIGHT}px + 16px)`,
    },
  }
})

export const ResponsivePageLayout = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  overflow: 'scroll',
  overflowX: 'hidden',
  [theme.breakpoints.up('md')]: {
    paddingLeft: `calc(min(20vw, ${DRAWER_DIMENSIONS.width.lg}px) + ${DRAWER_DIMENSIONS.margin.horizontal.lg}px)`,
  },
  [theme.breakpoints.between('md', 'lg')]: {
    height: `calc(var(--doc-height) - ${DRAWER_DIMENSIONS.margin.vertical.md * 2}px)`,
  },
  [theme.breakpoints.down('md')]: {
    padding: `0 0 ${BOTTOM_NAVIGATION_HEIGHT}px 0`,
  },
}))

export const PageLayout: React.FC<{ children: React.ReactNode }> = (props) => {
  return (
    <ResponsivePageLayout
      id={TestIds.pages.mainScrollContainer}
      data-testid={TestIds.pages.mainScrollContainer}
      className={TestIds.pages.mainScrollContainer}
      role='main'
    >
      <ResponseivePageBody>{props.children}</ResponseivePageBody>
    </ResponsivePageLayout>
  )
}
